import { render } from "./SignUpCreateOrganization.vue?vue&type=template&id=2fcbad10&scoped=true"
import script from "./SignUpCreateOrganization.vue?vue&type=script&lang=js"
export * from "./SignUpCreateOrganization.vue?vue&type=script&lang=js"

import "./SignUpCreateOrganization.vue?vue&type=style&index=0&id=2fcbad10&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcbad10"]])

export default __exports__